import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  sendOTP({ commit }, { userId, notificationType } = {}) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.adminApiPath.sendotp
    }/${userId}/${notificationType}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  validateotp({ commit }, { userId, otp, mclId, mclpassword } = {}) {
    var otpData = JSON.stringify({
      MCLId: mclId,
      OTP: otp,
      MCLPassword: mclpassword,
      UserId: userId,
    })
    var url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.verifyotp}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(url, JSON.parse(otpData), {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchOTPOptions({ commit }, { userId } = {}) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.adminApiPath.getotpoptions
    }/${userId}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
}
